<div class="cohort-donut-card">
  <div class="card-head">
    <h3 class="card-title">Cohort Readiness</h3>
    <span class="assessed-badge">{{ kpis.assessed }} assessed</span>
  </div>

  <div class="chart-content">
    <!-- SVG Donut Chart with Center Score -->
    <div class="donut-wrapper">
      <svg class="donut-svg" viewBox="0 0 120 120">
        <!-- Background Track -->
        <circle 
          cx="60" 
          cy="60" 
          r="46" 
          fill="none" 
          stroke="#f0eff4" 
          stroke-width="12" />

        <!-- Segment Arcs -->
        <g transform="rotate(-90 60 60)">
          <circle
            *ngFor="let seg of segments"
            cx="60"
            cy="60"
            r="46"
            fill="none"
            [attr.stroke]="seg.strokeColor"
            stroke-width="12"
            stroke-linecap="round"
            [attr.stroke-dasharray]="seg.dashArray"
            [attr.stroke-dashoffset]="seg.dashOffset"
            class="donut-segment" />
        </g>
      </svg>

      <!-- Center Text -->
      <div class="center-content">
        <span class="center-score">{{ kpis.averageScore }}</span>
        <span class="center-label">Avg Readiness</span>
      </div>
    </div>

    <!-- Cohort Breakdown Legend -->
    <ul class="cohort-legend">
      <li *ngFor="let item of cohort" class="legend-row">
        <span class="legend-label">
          <span class="indicator-bar" [style.backgroundColor]="colors[item.band]"></span>
          {{ item.label }}
        </span>
        <span class="legend-values">
          <strong class="count-value">{{ item.count }}</strong>
          <span class="percent-value">{{ item.percent }}%</span>
        </span>
      </li>
    </ul>
  </div>
</div>
